import PropTypes from 'prop-types';
import React from 'react';

const FocusLink = ({
  id, ariaLabel, styleClasses, children,
}) => {
  const ACTIVATION_KEYS = new Set(['Enter', ' ']);

  const preventStaticLinkDefault = (event) => {
    if (event.type === 'click') {
      event.preventDefault();
      return;
    }

    if (ACTIVATION_KEYS.has(event.key)) {
      event.preventDefault();
    }
  };

  return (
    <a
      id={id}
      href="#"
      className={styleClasses}
      onClick={preventStaticLinkDefault}
      onKeyDown={preventStaticLinkDefault}
      aria-label={ariaLabel}
    >
      { children }
    </a>
  );
};

FocusLink.propTypes = {
  id: PropTypes.string.isRequired,
  ariaLabel: PropTypes.string.isRequired,
  styleClasses: PropTypes.string,
  children: PropTypes.node.isRequired,
};

FocusLink.defaultProps = {
  styleClasses: 'contact-card__focus-link block no-underline outline-none',
};

export default FocusLink;
